import { useSite } from "@/context/SiteContext";
import { API } from "@/lib/api";

const Badge = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <defs>
      <linearGradient id="lg-gold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#BF953F" /><stop offset=".35" stopColor="#FCF6BA" />
        <stop offset=".6" stopColor="#B38728" /><stop offset="1" stopColor="#AA771C" />
      </linearGradient>
    </defs>
    <path d="M32 2 58 12v20c0 15-11 25-26 30C17 57 6 47 6 32V12Z" fill="#0B2B1E" stroke="url(#lg-gold)" strokeWidth="3" />
    <path d="M20 40c4-10 20-10 24 0M24 24h16M32 18v28" stroke="url(#lg-gold)" strokeWidth="3.5" fill="none" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ size = 44, showText = true }) => {
  const { site } = useSite() || {};
  return (
    <span className="flex items-center gap-3" data-testid="site-logo">
      {site?.has_logo ? (
        <img src={`${API}/logo?v=${site.logo_version}`} alt="Logo Taller de Suspensiones La Gringa"
          style={{ height: size, width: "auto", maxWidth: size * 2.5 }} className="object-contain" />
      ) : (
        <img src="/logo.png" alt="Logo Taller de Suspensiones La Gringa" width={size} height={size} className="rounded-full object-cover" style={{ height: size, width: size }} />
      )}
      {showText && (
        <span className="leading-none">
          <span className="block font-display text-[10px] font-bold uppercase tracking-[0.2em] text-mute">Taller de Suspensiones</span>
          <span className="block font-display text-xl font-extrabold text-green">La Gringa</span>
        </span>
      )}
    </span>
  );
};
